import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/SalesOrder'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class SalesOrderStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "SalesOrderStore",
			variables: true,
		})
	}
}

export async function load_SalesOrder(params) {
  await initClient()

	const store = new SalesOrderStore()

	await store.fetch(params)

	return {
		SalesOrder: store,
	}
}
